export default "__VITE_ASSET__DFmpjsnQ__"